import { render, staticRenderFns } from "./UiButton.vue?vue&type=template&id=3864f192&scoped=true&"
import script from "./UiButton.vue?vue&type=script&lang=js&"
export * from "./UiButton.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./UiButton.vue?vue&type=style&index=0&id=3864f192&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3864f192",
  null
  ,true
)

export default component.exports